/**
 * ScanFlow-PWA — Routing.
 *
 * Phase 2: Login, Inbox, Beleg-Detail, Profil, Change-Password.
 * Scannen (/erfassen): Kamera → Übersicht → Zuordnung → KI (Scanner 0.7).
 */
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import {
  LoginCard,
  ChangePasswordCard,
  ProfileCard,
  RequireAuth,
  MTabs,
  MVersionsZeile,
} from "@vimaana/ui";
import InboxPage from "./pages/InboxPage";
import BelegDetailPage from "./pages/BelegDetailPage";
import FeedbackPage from "./pages/FeedbackPage";
import CapturePage from "./pages/CapturePage";
import HelferKontoPage from "./pages/HelferKontoPage";
import PrivatListPage from "./pages/PrivatListPage";
import PrivatDetailPage from "./pages/PrivatDetailPage";

const APP_NAME = "scanflow";
const APP_TITLE = "Vimaana ScanFlow";

export default function App() {
  return (
    <Routes>
      <Route
        path="/login"
        element={<LoginCard appName={APP_NAME} appTitle={APP_TITLE} redirectAfterLogin="/inbox" />}
      />
      <Route
        path="/*"
        element={
          <RequireAuth appName={APP_NAME}>
            <Routes>
              <Route
                path="/change-password"
                element={<ChangePasswordCard appName={APP_NAME} redirectAfter="/inbox" />}
              />
              <Route
                path="/profil"
                element={<ProfilWithFeedback />}
              />
              <Route path="/inbox" element={<InboxPage />} />
              <Route path="/beleg/:id" element={<BelegDetailPage />} />
              <Route path="/erfassen" element={<CapturePage />} />
              <Route path="/helfer-konto" element={<HelferKontoPage />} />
              <Route path="/privat" element={<PrivatListPage />} />
              <Route path="/privat/:id" element={<PrivatDetailPage />} />
              <Route path="/erfassen/kamera" element={<Navigate to="/erfassen" replace />} />
              <Route path="/feedback" element={<FeedbackPage />} />
              <Route path="*" element={<Navigate to="/inbox" replace />} />
            </Routes>
          </RequireAuth>
        }
      />
    </Routes>
  );
}

// Bottom-Navigation der ScanFlow-PWA (identisch zu Feedback/Inbox).
const PROFIL_TABS = [
  { id: "inbox", label: "Rechnungen", ic: "📥", to: "/inbox" },
  { id: "erfassen", label: "Scannen", ic: "📷", to: "/erfassen" },
  { id: "profil", label: "Profil", ic: "◌", to: "/profil" },
];

// Profil mit Feedback-Sektion — eigener Wrapper, weil ProfileCard
// `extraSections` als beliebigen ReactNode akzeptiert.
// B1-Fix: Bottom-Tabs einhängen, damit man aus dem Profil wieder herauskommt
// (ProfileCard selbst rendert keine Navigation).
function ProfilWithFeedback() {
  const navigate = useNavigate();
  return (
    <>
      <ProfileCard
        appName={APP_NAME}
        appTitle={`${APP_TITLE} · Konto`}
        extraSections={
          <>
            <section className="profile-card">
              <h3 className="profile-h">Helfer-Konto</h3>
              <p style={{ fontSize: 13, color: "var(--m-ink-3)", marginBottom: 10 }}>
                Guthaben-Übersicht: verdient, berechnet und ausgezahlt je Helfer.
              </p>
              <button className="login-btn" onClick={() => navigate("/helfer-konto")}>
                Helfer-Konto öffnen
              </button>
            </section>
            <section className="profile-card">
              <h3 className="profile-h">Private Dokumente</h3>
              <p style={{ fontSize: 13, color: "var(--m-ink-3)", marginBottom: 10 }}>
                Firmenfremde Belege (Garantiequittungen, Arztschreiben …) — getrennt abgelegt, per Tag sortiert.
              </p>
              <button className="login-btn" onClick={() => navigate("/privat")}>
                Private Dokumente öffnen
              </button>
            </section>
            <section className="profile-card">
              <h3 className="profile-h">Feedback</h3>
              <p style={{ fontSize: 13, color: "var(--m-ink-3)", marginBottom: 10 }}>
                Bug, Idee oder Hinweis? Schreib uns direkt aus der App.
              </p>
              <button className="login-btn" onClick={() => navigate("/feedback")}>
                Feedback geben
              </button>
            </section>
            <MVersionsZeile name="ScanFlow" />
          </>
        }
      />
      <MTabs items={PROFIL_TABS} />
    </>
  );
}
